<template>
  <div>
      <div v-if="langSet == 'zh'" v-title data-title="我的"></div>
      <div v-if="langSet == 'en'" v-title data-title="My"></div>
      <!-- 头部 -->
      <top></top>
      <el-row class="hidden-sm-and-up">
        <el-col>
          <div class="mineNav-left">
            <ul class="mineNav">
              <li class="active" @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-down"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectMChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectMChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} 
                  <i class="el-icon-arrow-down"></i>
                </p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandMChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandMChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandMChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <!-- <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li> -->
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row class="exmain">
        <el-col :xs="xsNumLeft" :sm="xsNumLeft" :md="3" :lg="3" :xl="4"></el-col>
        <el-col :xs="xsNumLeftNav" :sm="xsNumLeftNav" :md="5" :lg="2" :xl="2" class="hidden-sm-and-down">
          <div class="mineNav-left">
            <ul class="mineNav">
              <li class="active">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <!-- <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li> -->
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
        <el-col :xs="xsNum" :sm="xsNum" :md="14" :lg="14" :xl="10">
          <div class="main-right" :style="{minHeight:height}">
            <div class="data-main">
              <div class="data-infor">
                <img v-if="userInfo.avatar.length > 0" class="data-avatar" :src="$imgUrl + userInfo.avatar" alt="">
                <img v-else class="data-avatar" src="../../assets/logo.jpg" alt="">
                <div class="data-text">
                  <p class="data-nickname">{{userInfo.nickname}} 
                    <span v-if="userInfo.dutiesName != null && langSet == 'zh' || userInfo.en_dutiesName == null">{{userInfo.dutiesName}}</span>
                    <span v-if="userInfo.en_dutiesName != null && langSet == 'en' && userInfo.en_dutiesName.length > 0">{{userInfo.en_dutiesName}}</span>
                  </p>
                  <p>{{userInfo.company_Name}}</p>
                </div>
                <img class="data-edit" @click="toEdit" src="../../assets/bianji.png" alt="">
              </div>
              <div class="hotline-data">
                {{$t('exhibitor.hotline')}}：400-006-8866
              </div>
              <!-- <div class="data-btn" @click="vertifyBtn" v-if="userInfo.companyid == 0">{{$t('exhibitor.exhibitorVerification')}}</div> -->
              <div class="loginout" v-if="memberid > 0" @click="logOut">{{langSet == 'zh'?'退出登录':'Logout'}}</div>
            </div>
            <verify v-if="isShowVertify" @close-vertify="closeVertify"></verify>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import verify from "./components/verify.vue";
import { getUser } from "@/api/api";
export default {
  components: { top,  bottom, verify},
  name: "mine",
  data() {
    return {
        isSHowSub:false,
        isSHowSubDemand:false,
        isShowVertify: false,
        isEdit: false,
        userInfo:{
          avatar:''
        },
        height: '',
        memberid: '',
        langSet: '',
        xsNumLeft: 1,
        xsNumLeftNav: 4,
        xsNum: 18
      }
    },
    created() {
    },
    mounted() {
      this.langSet = localStorage.getItem('languageSet') || 'zh';
      this.memberid = localStorage.getItem('memberid');
      this.getData();
      this.setHeight();
      if(this._isMobile()) {
        this.xsNumLeft = 1;
        this.xsNumLeftNav = 0;
        this.xsNum = 22;
      }else{
        this.xsNumLeft = 1;
        this.xsNumLeftNav = 4;
        this.xsNum = 18;
      }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    collectMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
      this.isSHowSub = !this.isSHowSub;
    },
    demandMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
      this.isSHowSubDemand = !this.isSHowSubDemand;
    },
    setHeight(){
        this.height = window.innerHeight  - 175 + 'px';
    },
    handleOpen(key, keyPath) {
      //console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
    toPath(path){
      this.$router.push({path});
    },
    show(id){
      if(id == 0){
        this.isSHowSub = !this.isSHowSub;
      }else{
        this.isSHowSubDemand = !this.isSHowSubDemand;
      }
    },
    getData(){
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid:this.$uuid
      })
      getUser(data).then(res=>{
        //console.log(res.data.rst)
        if(res.data.errno == 0){
          this.userInfo = res.data.rst;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    toEdit(){
      this.$router.push({name: 'dataEdit'});
    },
    collectChange(index){
      //console.log(index)
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
    },
    demandChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
    },
    vertifyBtn(){
      this.isShowVertify = true;
    },
    closeVertify(data){
      this.isShowVertify = data;
    },
    logOut(){
      this.$store.dispatch("userLogin", false);
      // localStorage.setItem("Flag", false);
      // localStorage.setItem("memberid", 0);
      // localStorage.setItem("uuid", 0);
      localStorage.removeItem('Flag');
      localStorage.removeItem('memberid');
      localStorage.removeItem('uuid');
      localStorage.removeItem('improve');
      location.reload();
    }
  }
}
</script>

<style lang="scss"  scoped>
.exmain .main-right{box-sizing: border-box;}
.main{padding-top: 40px;padding-left: 184px;}
.mineNav > li{font-size:20px;line-height:28px;color: #000;margin-bottom: 24px;cursor: pointer;width: 100px;text-align: center;}
.mineNav > li.active{color: #CAC28A;}
.mineNav > li p{position: relative;}
.mineNav > li p i{position: absolute;top: 5px;}
.mineNav > li .minesubnav{color: #666;font-size:18px;line-height: 25px;padding-bottom: 13px;text-align: center;}
.mineNav > li .minesubnav li{padding-top: 14px;}
.mineNav > li .minesubnav .active{color: #CAC28A;}
.data-infor{display: flex;width: 100%;background:rgba(243,243,243,1);border-radius:2px;padding: 21px 37px;align-items: center;position: relative;box-sizing:border-box;}
.data-infor .data-avatar{width:81px;height:81px;border:0px solid rgba(255,255,255,1);border-radius: 50%;margin-right: 20px;}
.data-text{font-size:16px;line-height: 22px;color: #666;}
.data-text .data-nickname{font-size:20px;line-height: 28px;color: #000;}
.data-text .data-nickname span{font-size:14px;color: #666;}
.data-edit{position: absolute;top: 16px;right: 25px;width:35px;height:35px;cursor: pointer;}
.hotline-data{height: 75px;line-height: 75px;background:rgba(243,243,243,1);border-radius:2px;padding:0 34px;margin: 14px 0 30px;font-size:20px;color: #000;box-sizing:border-box;width: 100%;}
.data-main .data-btn{width: 100%;height:75px;line-height: 75px;background:rgba(0,123,255,1);border-radius:9px;color: #fff;font-size: 30px;text-align: center;cursor: pointer;}
.loginout{color: #fff;font-size: 16px;width: 120px;height: 40px;line-height: 40px;border-radius: 10px;background:rgba(0,123,255,1);cursor: pointer;margin: 100px auto 0;text-align: center;}
.mineNav > li.inbox{background:rgba(224,153,149,1);border-radius:4px;color: #fff;font-size: 18px;}
@media only screen and (max-width: 767px){
  .mineNav{
    padding: 0 0.2rem;
    display: flex;
    margin-top: 0.2rem;
    li.inbox{font-size: 11px;}
    li{
      font-size: 11px;
      flex: 1;
      position: relative;
      margin-bottom: 0;
      p i{top: 0.18rem;}
      .minesubnav{
        font-size: 11px;
        line-height: 0.25rem;
        position: absolute;
        background: #fff;
        width: 100%;
        z-index: 999;
        li{padding-top: 0.14rem;}
      }
    } 
  }
  .data-infor{padding: 0.21rem 0.3rem;}
  .data-infor .data-avatar{width: 0.81rem;height: 0.81rem;margin-right: 0.2rem;}
  .data-edit{width: 0.35rem;height: 0.35rem;top: 0.16rem;right: 0.25rem;}
  .data-text .data-nickname{font-size: 16px;}
  .hotline-data{height: 0.75rem;line-height: 0.75rem;font-size: 16px;padding:0 0.34rem;}
  .data-main .data-btn{height: 0.75rem;line-height: 0.75rem;font-size: 20px;}
}
</style>